import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioLabelFn = /* @__PURE__ */ createRecipe('radio-label', {
  "size": "l"
}, [])

const radioLabelVariantMap = {
  "size": [
    "l",
    "m"
  ]
}

const radioLabelVariantKeys = Object.keys(radioLabelVariantMap)

export const radioLabel = /* @__PURE__ */ Object.assign(memo(radioLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioLabel',
  __getCompoundVariantCss__: radioLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioLabelVariantKeys,
  variantMap: radioLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioLabelVariantKeys)
  },
  getVariantProps: radioLabelFn.getVariantProps,
})